import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
import { auth, db } from "../../Security/firebase-config";
import "../General-Page.css";
import "./Corrode-Yoru.css";
import "../../utils/ImageHoverEffect.css";
import { applyImageZoomEffect } from '../../utils/ImageHoverEffect';
import Footer from "../../components/core-components/Footer";
import GuideImage from "../../components/core-components/GuideImage";
import Highlight from "../../components/core-components/Highlight";
import Favorites from "../../components/core-components/Favorites";
import { useBlur } from "../../context/BlurContext";
import LazyVideo from "../../components/core-components/LazyVideo";
import GuideMediaPlaceholder from "../../components/core-components/GuideMediaPlaceholder";
import MovementGuideModal from "../../components/core-components/MovementGuideModal";
import useAccordionDoubleClick from "../../hooks/useAccordionDoubleClick";
import {
  getGuideMediaPreloadSrc,
  isPlannedGuideMedia,
  plannedGuideImage,
  plannedGuideVideo,
} from "../../utils/guideMediaPlanning";




const mediaSources = {
  "How-to-Play-A-Retake-with-Ult": {
    "overview-image-a": plannedGuideImage(
      "Ind-Corrode/Yoru/Corrode-DEF-Yoru-A-retake-with-Ult.png"
    ),
    "retake-a-video": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-DEF-A-Retake-With-Ult-fast.mp4",
      { label: "Nanoswarm lineup" }
    ),
  },
  "How-to-Play-B-Retake-with-Ult": {
    "overview-image-b": plannedGuideImage(
      "Ind-Corrode/Yoru/Corrode-DEF-Yoru-B-retake-with-Ult.png"
    ),
  },
  "How-to-Play-C-Retake-with-Ult": {
    "overview-image-c": plannedGuideImage(
      "Ind-Corrode/Yoru/Corrode-DEF-Yoru-C-retake-with-Ult.png"
    ),
    "retake-c-video": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-DEF-C-Retake-With-Ult-fast.mp4",
      { label: "Nanoswarm lineup" }
    ),
  },

  "A-Long-Trap-Play": {
    "trap-play-a-long-with-omen": plannedGuideVideo(
      "Ind-Corrode/Yoru/Corrode-Yoru-DEF-Trap-Play-A-Long-W-Omen-fast.mp4",
      {
        label: "Trap Play A-Long with Omen",
        props: {
          className: "slow-video",
          playbackRate: 0.7,
          loop: true,
        },
      }
    ),
  },

  "How-to-Default-As-Yoru": {
    "overview-image": plannedGuideImage("Ind-Corrode/Yoru/Corrode-Yoru-HTD.png"),
  },
  "C-or-Garage-Heavy-Default": {
    "a-lobby-nano": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-HTD-B-Main-Molly-From-A-Lobby-fast.mp4",
      { label: "B-Nano From A-Lobby" }
    ),
  },
  "A-Hit-with-4-or-A-Heavy-Default": {
    "c-spawn-nano": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-HTD-B-Main-Molly-From-C-Spawn-fast.mp4",
      { label: "B-Nano From C T-Spawn" }
    ),
  },
  "A-Hit-from-Long": {
    "overview-video": plannedGuideVideo(
      "Ind-Corrode/Yoru/Corrode-Yoru-ATK-A-site-from-long-fast.mp4",
      {
        props: {
          className: "slow-video",
          playbackRate: 0.7,
          loop: true,
        },
      }
    ),
    "ct-nanoswarm": plannedGuideVideo(
      "Ind-Corrode/Yoru/Corrode-Yoru-ATK-A-CT-Molly-fast.mp4",
      { label: "CT-Nanoswarm" }
    ),
    "back-site-nanoswarm": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-A-Back-Site-Molly-fast.mp4",
      { label: "Back-Site-Nanoswarm" }
    ),
    "god-smoke-nanoswarm": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-A-God-Smoke-Molly-fast.mp4",
      { label: "God-Smoke-Nanoswarm" }
    ),
  },
  "C-Long-Hit-Committed": {
    "filler-video": plannedGuideVideo("Ind-Corrode/Yoru/Filler.mp4", {
      label: "Overview (Filler)",
    }),
    "back-plat-molly": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-Back-Plat-Molly-fast.mp4",
      { label: "Back Plat Molly" }
    ),
    "ct-molly": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-CT-Molly-fast.mp4",
      { label: "CT Molly" }
    ),
    "garage-molly": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-Garage-Molly-fast.mp4",
      { label: "Garage Molly" }
    ),
    "ct-garage-rollout": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-CT&Garage-Molly-Rollout-fast.mp4",
      { label: "CT & Garage Molly Rollout" }
    ),
  },
  "C-Split": {
    "overview-video": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-CT-Overview-From-Grass-fast.mp4",
      { label: "Overview from Grass" }
    ),
    "ct-nano-from-grass": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-CT-Molly-From-Grass-fast.mp4",
      { label: "CT Molly from Grass" }
    ),
  },
  "A-PP-Nano": {
    "overview-image-a-pp": plannedGuideImage(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-A-PP.png"
    ),
    "molly-from-a-link": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-A-PP-Molly-From-A-Link-fast.mp4",
      { label: "Nanoswarm lineup from A-Link" }
    ),
    "molly-from-far-a-long": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-A-PP-Molly-From-Far-A-Long-fast.mp4",
      { label: "Nanoswarm lineup from Far A-Long" }
    ),
  },
  "C-PP-Nano": {
    "overview-image-c-pp": plannedGuideImage(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-PP.png"
    ),
    "molly-from-c-link": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-PP-From-C-Link-fast.mp4",
      { label: "Nanoswarm lineup from C-Link" }
    ),
    "molly-from-c-long": plannedGuideVideo(
      "Ind-Corrode/Yoru/Ind-Corrode-Yoru-ATK-C-PP-From-C-Long-fast.mp4",
      { label: "Nanoswarm lineup from C-Long" }
    ),
  },
};



const CorrodeYoru= () => {
  const [userTeamId, setUserTeamId] = useState(null);
  const imageContainerRef = useRef(null);
  const { isBlurred } = useBlur(); // Access blur state
  const [selectedImage, setSelectedImage] = useState("image1");
  const [selectedMediaBySection, setSelectedMediaBySection] = useState({});
  const [openAccordions, setOpenAccordions] = useState({});
  useAccordionDoubleClick({ openAccordions, setOpenAccordions });
  const location = useLocation();
  const [isMovementGuideOpen, setIsMovementGuideOpen] = useState(false);


  // ✅ Auto-expand accordions & scroll to highlight
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const highlightId = params.get("highlight");

    if (highlightId) {
      const accordionMap = {
        // ✅ Defense
        "Indiv-Corrode-Yoru-Standard-Setups": ["Defense-Main", "Standard-Setups"],
        "Indiv-Corrode-Yoru-A-Site-Anchor-Setup": ["Defense-Main", "Standard-Setups", "A-Site-Anchor-Setup"],
        "Indiv-Corrode-Yoru-B-Site-and-Garage-Setup": ["Defense-Main", "Standard-Setups", "B-Site-and-Garage-Setup"],
        "Indiv-Corrode-Yoru-C-Site-and-Garage-Setup": ["Defense-Main", "Standard-Setups", "C-Site-and-Garage-Setup"],
        "Indiv-Corrode-Yoru-C-Site-Anchor-Setup": ["Defense-Main", "Standard-Setups", "C-Site-Anchor-Setup"],
      
        "Indiv-Corrode-Yoru-Retake-Setups": ["Defense-Main", "Retake-Setups"],
        "Indiv-Corrode-Yoru-ARetake": ["Defense-Main", "Retake-Setups", "ARetake"],
        "Indiv-Corrode-Yoru-BRetake": ["Defense-Main", "Retake-Setups", "BRetake"],
        "Indiv-Corrode-Yoru-CRetake": ["Defense-Main", "Retake-Setups", "CRetake"],
      
        "Indiv-Corrode-Yoru-Defensive-Set-Plays": ["Defense-Main", "Defensive-Set-Plays"],
        "Indiv-Corrode-Yoru-Eco-Strats": ["Defense-Main", "Defensive-Set-Plays", "Eco-Strats"],
        "Indiv-Corrode-Yoru-A-short-Shorty-trap": ["Defense-Main", "Defensive-Set-Plays", "Eco-Strats", "A-short-Shorty-trap"],
        "Indiv-Corrode-Yoru-Walk-down-Mid": ["Defense-Main", "Defensive-Set-Plays", "Eco-Strats", "Walk-down-Mid"],
        "Indiv-Corrode-Yoru-Garage-short-range": ["Defense-Main", "Defensive-Set-Plays", "Eco-Strats", "Garage-short-range"],
        "Indiv-Corrode-Yoru-Walk-down-C-long": ["Defense-Main", "Defensive-Set-Plays", "Eco-Strats", "Walk-down-C-long"],
      
        "Indiv-Corrode-Yoru-Trap-Plays": ["Defense-Main", "Defensive-Set-Plays", "Trap-Plays"],
        "Indiv-Corrode-Yoru-A-Short-Trap-Play": ["Defense-Main", "Defensive-Set-Plays", "Trap-Plays", "A-Short Trap Play"],
        "Indiv-Corrode-Yoru-A-Long-Trap-Play": ["Defense-Main", "Defensive-Set-Plays", "Trap-Plays", "A-Long Trap Play"],
        "Indiv-Corrode-Yoru-Garage-Trap": ["Defense-Main", "Defensive-Set-Plays", "Trap-Plays", "Garage-Trap-Play"],
      
        "Indiv-Corrode-Yoru-Plans-Ultimates": ["Defense-Main", "Defensive-Set-Plays", "Plans-Ultimates"],
        "Indiv-Corrode-Yoru-How-to-Play-A-Retake-with-Ult": ["Defense-Main", "Defensive-Set-Plays", "Plans-Ultimates", "How-to-Play-A-Retake-with-Ult"],
        "Indiv-Corrode-Yoru-How-to-Play-B-Retake-with-Ult": ["Defense-Main", "Defensive-Set-Plays", "Plans-Ultimates", "How-to-Play-B-Retake-with-Ult"],
        "Indiv-Corrode-Yoru-How-to-Play-C-Retake-with-Ult": ["Defense-Main", "Defensive-Set-Plays", "Plans-Ultimates", "How-to-Play-C-Retake-with-Ult"],
      
        // ✅ Attack
        "Indiv-Corrode-Yoru-Site-Hit-Positioning-and-Pathing": ["Attack-Main", "Site-Hit-Positioning-and-Pathing"],
        "Indiv-Corrode-Yoru-A-Hit-Committed": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "A-Hit-Committed"],
        "Indiv-Corrode-Yoru-B-Hit": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "B-Hit"],
        "Indiv-Corrode-Yoru-C-Long-Hit-Committed": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "C-Long-Hit-Committed"],
        "Indiv-Corrode-Yoru-C-Split": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "C-Split"],
        "Indiv-Corrode-Yoru-A-Site-Ult": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "A-Site-Ult"],
        "Indiv-Corrode-Yoru-B-Site-Ult": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "B-Site-Ult"],
        "Indiv-Corrode-Yoru-C-Site-Ult": ["Attack-Main", "Site-Hit-Positioning-and-Pathing", "C-Site-Ult"],
      
        "Indiv-Corrode-Yoru-How-to-Default-As-Yoru": ["Attack-Main", "How-to-Default-As-Yoru"],
        "Indiv-Corrode-Yoru-A-Hit-with-4-or-A-Heavy-Default": ["Attack-Main", "How-to-Default-As-Yoru", "A-Hit-with-4-or-A-Heavy-Default"],
        "Indiv-Corrode-Yoru-Team-Heavy-B-or-Garage-Default": ["Attack-Main", "How-to-Default-As-Yoru", "Team-Heavy-B-or-Garage-Default"],
        "Indiv-Corrode-Yoru-C-or-Garage-Heavy-Default": ["Attack-Main", "How-to-Default-As-Yoru", "C-or-Garage-Heavy-Default"],
      
        "Indiv-Corrode-Yoru-Post-Plants": ["Attack-Main", "Post-Plants"],
        "Indiv-Corrode-Yoru-A-PP-Nano": ["Attack-Main", "Post-Plants", "A-PP-Nano"],
        "Indiv-Corrode-Yoru-B-PP-Nano": ["Attack-Main", "Post-Plants", "B-PP-Nano"],
        "Indiv-Corrode-Yoru-C-PP-Nano": ["Attack-Main", "Post-Plants", "C-PP-Nano"],
      
        // ✅ Common Agent Combos
        "Indiv-Corrode-Yoru-Common-Agent-Combos": ["Common-Agent-Combos"]
      };
      
      

      const pathsToOpen = accordionMap[highlightId];

      if (pathsToOpen) {
        setOpenAccordions((prev) => {
          const updated = { ...prev };
          pathsToOpen.forEach((key) => {
            updated[key] = true;
          });
          sessionStorage.setItem("CorrodeYoruAccordionState", JSON.stringify(updated));
          return updated;
        });

        // Give time for accordion to render
        setTimeout(() => {
          const el = document.querySelector(`[data-container-id="${highlightId}"]`);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 500);
      }
    }
  }, [location.search]);

  useEffect(() => {
    const imageContainers = document.querySelectorAll(".image-hover-effect");
  
    if (imageContainers.length > 0) {
      const cleanupFunctions = [];
  
      imageContainers.forEach((container) => {
        const cleanup = applyImageZoomEffect(container);
        cleanupFunctions.push(cleanup);
      });
  
      return () => {
        cleanupFunctions.forEach((cleanup) => cleanup());
      };
    }
  }, []);
  

   // ✅ Hydrate all sessionStorage state on mount
   useEffect(() => {
    const storedAccordionState = sessionStorage.getItem("CorrodeYoruAccordionState");
    if (storedAccordionState) {
      try {
        const parsed = JSON.parse(storedAccordionState);
        setOpenAccordions(parsed);
  
        // ✅ Also hydrate default media if not already selected
        const newMediaState = {};
          Object.entries(parsed).forEach(([accordionId, isOpen]) => {
            if (isOpen && mediaSources[accordionId]) {
              const firstKey = Object.keys(mediaSources[accordionId])[0];
              if (firstKey) {
                newMediaState[accordionId] = firstKey;
              }
            }
          });
          if (Object.keys(newMediaState).length > 0) {
            setSelectedMediaBySection((prev) => ({
              ...prev,
              ...newMediaState
            }));
          }

        
      } catch (e) {
        console.error("Failed to parse accordion state", e);
      }
    }
  }, []);
  

  // ✅ Persist selectedMediaBySection
  useEffect(() => {
    sessionStorage.setItem("CorrodeYoruMediaState", JSON.stringify(selectedMediaBySection));
  }, [selectedMediaBySection]);

  // ✅ Persist selectedImage
  useEffect(() => {
    sessionStorage.setItem("CorrodeYoruSelectedImage", selectedImage);
  }, [selectedImage]);
    

  useEffect(() => {
    if (imageContainerRef.current) {  // ✅ Ensure the element exists
      const cleanup = applyImageZoomEffect(imageContainerRef.current); 
  
      return () => {
        cleanup();
      };
    }
  }, []);  

  useEffect(() => {
    console.log("userTeamId in CorrodeMapApproach:", userTeamId);
  }, [userTeamId]);

  useEffect(() => {
    const fetchUserTeamId = async (uid) => {
      try {
        const userDocRef = doc(db, "users", uid);
        console.log("Fetching user document:", userDocRef.path); // Log the Firestore path
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          console.log("Fetched user document data:", data); // Log the document data

          if (data.teamId) {
            console.log("Setting teamId:", data.teamId);
            setUserTeamId(data.teamId);
          } else {
            console.warn("No teamId found in user document. Setting teamId to null.");
            setUserTeamId(null);
          }
        } else {
          console.error("User document does not exist in Firestore.");
        }
      } catch (error) {
        console.error("Error fetching user team ID:", error);
      }
    };

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is authenticated:", user.uid);
        fetchUserTeamId(user.uid); // Pass the UID to fetch the teamId
      } else {
        console.warn("No authenticated user found.");
        setUserTeamId(null); // Clear the teamId if the user logs out
      }
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  // Page transition effect
  useEffect(() => {
    document.body.classList.add("no-transition");
    const pageContainer = document.querySelector(".page__container");
    pageContainer && pageContainer.classList.add("no-transition");

    const handleLoad = () => {
      document.body.classList.remove("no-transition");
      pageContainer && pageContainer.classList.remove("no-transition");
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

   // ✅ Accordion toggle logic
   const handleAccordionToggle = (accordionId, type) => {
    setOpenAccordions((prev) => {
      const isOpen = !prev[accordionId];
      const updated = { ...prev, [accordionId]: isOpen };
      sessionStorage.setItem("CorrodeYoruAccordionState", JSON.stringify(updated));

      // only preload this section’s media when it’s opened
      if (isOpen && mediaSources[accordionId]) {
        const entries = Object.values(mediaSources[accordionId]);
        // 1️⃣ “Auto”-buffer the first (default) video immediately
        const firstVideoSrc = getGuideMediaPreloadSrc(entries[0]);
        if (firstVideoSrc) {
          const v0 = document.createElement("video");
          v0.src = firstVideoSrc;
          v0.preload = "auto";
          v0.load();
        }
        // 2️⃣ schedule metadata-only preloads for the rest during idle
        entries.slice(1).forEach((entry) => {
          const src = getGuideMediaPreloadSrc(entry);
          if (!src) {
            return;
          }
          const doMeta = () => {
            const v = document.createElement("video");
            v.src = src;
            v.preload = "metadata";
            v.load();
          };
          if ("requestIdleCallback" in window) {
            requestIdleCallback(doMeta, { timeout: 2000 });
          } else {
            setTimeout(doMeta, 2000);
          }
        });
      }
  

      if (isOpen) {
        if (type === "image") {
          setSelectedImage("image1");
        }

        if (type === "media" && mediaSources[accordionId]) {
          const firstKey = Object.keys(mediaSources[accordionId])[0];
          if (firstKey) {
            setSelectedMediaBySection((prev) => ({
              ...prev,
              [accordionId]: firstKey
            }));
          }
        }        
      }

      return updated;
    });
  };

  const renderMediaButtons = (sectionId) => {
    const sectionMedia = mediaSources[sectionId];
    if (!sectionMedia) return null;
  
    return (
      <>
        <button
        onClick={() => {
          console.log("Movement Guide button clicked ✅");
          setIsMovementGuideOpen(true);
        }}
        className="movement-guide-question-button"
      >
        ?
      </button>
        {Object.entries(sectionMedia).map(([key, { label }]) => (
          <button
            key={key}
            onClick={() =>
              setSelectedMediaBySection((prev) => ({
                ...prev,
                [sectionId]: key,
              }))
            }
            className={selectedMediaBySection[sectionId] === key ? "active" : ""}
          >
            {label}
          </button>
        ))}
      </>
    );
  };
  
  const renderSelectedMedia = (sectionId) => {
    const selectedKey = selectedMediaBySection[sectionId];
    const sectionMedia = mediaSources[sectionId];
  
    if (!selectedKey || !sectionMedia || !sectionMedia[selectedKey]) return null;
  
    const entry = sectionMedia[selectedKey];
    const { type, src, props = {} } = entry;

    if (isPlannedGuideMedia(entry)) {
      return <GuideMediaPlaceholder key={selectedKey} entry={entry} withFrame={false} />;
    }
  
    if (type === "image") {
      return <GuideImage key={selectedKey} src={src} alt={selectedKey} {...props} />;
    } else if (type === "video") {
      return (
        <LazyVideo
          key={selectedKey}
          src={src}
          preload="auto"
          forceLoad={true}            // ← add this
          {...props}
        />
      );
    }
  
    return null;
  };
  
  
  

  return (
    <div className={`page__container ${isBlurred ? "blurred-content" : ""}`}>
    <MovementGuideModal isOpen={isMovementGuideOpen} onClose={() => setIsMovementGuideOpen(false)} />
    <Highlight />
    <main className={`Main__content__container ${isBlurred ? "blurred-content" : ""}`}>
      <h1 className="M-A-Title">Corrode Yoru</h1> {/* Page Title */}

      <ul className="accordian"> 
        <li>
          <input
            type="checkbox"
            name="accordion-defense"
            id="Indiv-Corrode-Yoru-Defense-Main"
            checked={!!openAccordions["Defense-Main"]}
            onChange={() => handleAccordionToggle("Defense-Main")}
          />
          <label htmlFor="Indiv-Corrode-Yoru-Defense-Main">Defense</label>
          <div className="accordian__content">
            <ul>
              {/* <!-- Standard Setups --> */}
              <li>
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Corrode-Yoru-Standard-Setups"
                  checked={!!openAccordions["Standard-Setups"]}
                  onChange={() => handleAccordionToggle("Standard-Setups")}
                />
                <label htmlFor="Indiv-Corrode-Yoru-Standard-Setups">
                  Standard Setups
                  <Favorites
                    headingId="Indiv-Corrode-Yoru-Standard-Setups"
                    headingContent="Standard Setups"
                    pageLocation="/Corrode-Yoru"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content">
                  <ul>
                    {[
                      { id: "A-Site-Anchor-Setup", label: "A-Site Anchor Setup" },
                      { id: "B-Site-and-Garage-Setup", label: "B-Site & Garage Setup" },
                      { id: "C-Site-and-Garage-Setup", label: "C-Site & Garage Setup" },
                      { id: "C-Site-Anchor-Setup", label: "C-Site Anchor Setup" }
                    ].map(({ id, label }) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="StandardSetups-sub"
                          id={`Indiv-Corrode-Yoru-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Corrode-Yoru-${id}`}
                            headingContent={label}
                            pageLocation="/Corrode-Yoru"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Ind-Corrode-Yoru-DEF-${label.replace(/\s+/g, "-")}`}>
                          <div className="image-selector">
                            {renderMediaButtons(id)}
                          </div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect">
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Setup strategy for {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* <!-- Retake Setups --> */}
              <li>
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Corrode-Yoru-Retake-Setups"
                  checked={!!openAccordions["Retake-Setups"]}
                  onChange={() => handleAccordionToggle("Retake-Setups")}
                />
                <label htmlFor="Indiv-Corrode-Yoru-Retake-Setups">
                  Retake Setups
                  <Favorites
                    headingId="Indiv-Corrode-Yoru-Retake-Setups"
                    headingContent="Retake Setups"
                    pageLocation="/Corrode-Yoru"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content">
                  <ul>
                    {["ARetake", "BRetake", "CRetake"].map((id) => {
                      const label = id.replace(/([A-Z])/, "$1-"); // e.g., "ARetake" => "A-Retake"
                      return (
                        <li key={id}>
                          <input
                            type="checkbox"
                            name="RetakeSetups-sub"
                            id={`Indiv-Corrode-Yoru-${id}`}
                            checked={!!openAccordions[id]}
                            onChange={() => handleAccordionToggle(id, "media")}
                          />
                          <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                            {label}
                            <Favorites
                              headingId={`Indiv-Corrode-Yoru-${id}`}
                              headingContent={label}
                              pageLocation="/Corrode-Yoru"
                              teamId={userTeamId}
                            />
                          </label>
                          <div className="accordian__content" data-container-id={`Ind-Corrode-Yoru-DEF-${label}`}>
                            <div className="image-selector">
                              {renderMediaButtons(id)}
                            </div>
                            <div className="retake-content__wrapper">
                              <div className="image__container">
                                <div className="Image-Border image-hover-effect">
                                  {renderSelectedMedia(id)}
                                </div>
                              </div>
                              <div className="retake-text__container">
                                <p>Retake setup for {label}.</p>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>

              <li> 
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Corrode-Yoru-Defensive-Set-Plays"
                  checked={!!openAccordions["Defensive-Set-Plays"]}
                  onChange={() => handleAccordionToggle("Defensive-Set-Plays")}
                />
                <label htmlFor="Indiv-Corrode-Yoru-Defensive-Set-Plays">
                  Defensive Set-Plays
                  <Favorites
                    headingId="Indiv-Corrode-Yoru-Defensive-Set-Plays"
                    headingContent="Defensive Set-Plays"
                    pageLocation="/Corrode-Yoru"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content">
                  <ul>

                    {/* <!-- Eco Strats --> */}
                    <li>
                      <input
                        type="checkbox"
                        name="DefensiveSetPlays-sub"
                        id="Indiv-Corrode-Yoru-Eco-Strats"
                        checked={!!openAccordions["Eco-Strats"]}
                        onChange={() => handleAccordionToggle("Eco-Strats")}
                      />
                      <label htmlFor="Indiv-Corrode-Yoru-Eco-Strats">
                        Eco Strats
                        <Favorites
                          headingId="Indiv-Corrode-Yoru-Eco-Strats"
                          headingContent="Eco Strats"
                          pageLocation="/Corrode-Yoru"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content">
                        <ul>
                          {[
                            "A-short Shorty trap",
                            "Walk down Mid",
                            "Garage short range",
                            "Walk down C-long"
                          ].map((title) => {
                            const id = title.replace(/\s+/g, "-");
                            return (
                              <li key={id}>
                                <input
                                  type="checkbox"
                                  name="EcoStrats-sub"
                                  id={`Indiv-Corrode-Yoru-${id}`}
                                  checked={!!openAccordions[id]}
                                  onChange={() => handleAccordionToggle(id, "media")}
                                />
                                <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                                  {title}
                                  <Favorites
                                    headingId={`Indiv-Corrode-Yoru-${id}`}
                                    headingContent={title}
                                    pageLocation="/Corrode-Yoru"
                                    teamId={userTeamId}
                                  />
                                </label>
                                <div className="accordian__content" data-container-id={`Ind-Corrode-Yoru-DEF-${id}`}>
                                  <div className="image-selector">
                                    {renderMediaButtons(id)}
                                  </div>
                                  <div className="retake-content__wrapper">
                                    <div className="image__container">
                                      <div className="Image-Border image-hover-effect">
                                        {renderSelectedMedia(id)}
                                      </div>
                                    </div>
                                    <div className="retake-text__container">
                                      <p>Eco tactic: {title}.</p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>

                    {/* <!-- Trap Plays --> */}
                    <li>
                      <input
                        type="checkbox"
                        name="DefensiveSetPlays-sub"
                        id="Indiv-Corrode-Yoru-Trap-Plays"
                        checked={!!openAccordions["Trap-Plays"]}
                        onChange={() => handleAccordionToggle("Trap-Plays")}
                      />
                      <label htmlFor="Indiv-Corrode-Yoru-Trap-Plays">
                        Trap Plays
                        <Favorites
                          headingId="Indiv-Corrode-Yoru-Trap-Plays"
                          headingContent="Trap Plays"
                          pageLocation="/Corrode-Yoru"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content">
                        <ul>
                          {["A-Short Trap Play", "A-Long Trap Play", "Garage Trap Play"].map((title) => {
                            const id = title.replace(/\s+/g, "-");
                            return (
                              <li key={id}>
                                <input
                                  type="checkbox"
                                  name="TrapPlays-sub"
                                  id={`Indiv-Corrode-Yoru-${id}`}
                                  checked={!!openAccordions[id]}
                                  onChange={() => handleAccordionToggle(id, "media")}
                                />
                                <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                                  {title}
                                  <Favorites
                                    headingId={`Indiv-Corrode-Yoru-${id}`}
                                    headingContent={title}
                                    pageLocation="/Corrode-Yoru"
                                    teamId={userTeamId}
                                  />
                                </label>
                                <div className="accordian__content" data-container-id={`Ind-Corrode-Yoru-DEF-${id}`}>
                                  <div className="image-selector">
                                    {renderMediaButtons(id)}
                                  </div>
                                  <div className="retake-content__wrapper">
                                    <div className="image__container">
                                      <div className="Image-Border image-hover-effect">
                                        {renderSelectedMedia(id)}
                                      </div>
                                    </div>
                                    <div className="retake-text__container">
                                      <p>Trap setup: {title}.</p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>

                    {/* <!-- Setups around Ultimate --> */}
                    <li>
                      <input
                        type="checkbox"
                        name="DefensiveSetPlays-sub"
                        id="Indiv-Corrode-Yoru-Plans-Ultimates"
                        checked={!!openAccordions["Plans-Ultimates"]}
                        onChange={() => handleAccordionToggle("Plans-Ultimates")}
                      />
                      <label htmlFor="Indiv-Corrode-Yoru-Plans-Ultimates">
                        Setups around Ultimate
                        <Favorites
                          headingId="Indiv-Corrode-Yoru-Plans-Ultimates"
                          headingContent="Setups around Ultimate"
                          pageLocation="/Corrode-Yoru"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content">
                        <ul>
                          {[
                            "How to Play A-Retake with Ult",
                            "How to Play B-Retake with Ult",
                            "How to Play C-Retake with Ult"
                          ].map((title) => {
                            const id = title.replace(/\s+/g, "-");
                            return (
                              <li key={id}>
                                <input
                                  type="checkbox"
                                  name="UltSetups-sub"
                                  id={`Indiv-Corrode-Yoru-${id}`}
                                  checked={!!openAccordions[id]}
                                  onChange={() => handleAccordionToggle(id, "media")}
                                />
                                <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                                  {title}
                                  <Favorites
                                    headingId={`Indiv-Corrode-Yoru-${id}`}
                                    headingContent={title}
                                    pageLocation="/Corrode-Yoru"
                                    teamId={userTeamId}
                                  />
                                </label>
                                <div className="accordian__content" data-container-id={`Ind-Corrode-Yoru-DEF-${id}`}>
                                  <div className="image-selector">
                                    {renderMediaButtons(id)}
                                  </div>
                                  <div className="retake-content__wrapper">
                                    <div className="image__container">
                                      <div className="Image-Border image-hover-effect">
                                        {renderSelectedMedia(id)}
                                      </div>
                                    </div>
                                    <div className="retake-text__container">
                                      <p>{title} strategy and placement.</p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

            </ul>
          </div>
        </li>


        {/* Attack Main Accordion */}
        <li>
          <input
            type="checkbox"
            name="accordion-attack"
            id="Indiv-Corrode-Yoru-Attack-Main"
            checked={!!openAccordions["Attack-Main"]}
            onChange={() => handleAccordionToggle("Attack-Main")}
          />
          <label htmlFor="Indiv-Corrode-Yoru-Attack-Main">Attack</label>
          <div className="accordian__content" data-container-id="Indiv-Corrode-Yoru-Attack-Main">
            <ul>

              {/* 1. Site-Hit Positioning & Pathing */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Corrode-Yoru-Site-Hit-Positioning-and-Pathing"
                  checked={!!openAccordions["Site-Hit-Positioning-and-Pathing"]}
                  onChange={() => handleAccordionToggle("Site-Hit-Positioning-and-Pathing")}
                />
                <label htmlFor="Indiv-Corrode-Yoru-Site-Hit-Positioning-and-Pathing">
                  Site-Hit Positioning & Pathing
                  <Favorites
                    headingId="Indiv-Corrode-Yoru-Site-Hit-Positioning-and-Pathing"
                    headingContent="Site-Hit Positioning & Pathing"
                    pageLocation="/Corrode-Yoru"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content" data-container-id="Indiv-Corrode-Yoru-Site-Hit-Positioning-and-Pathing">
                  <ul>
                    {[
                      ["A-Hit-Committed", "A-Hit Committed"],
                      ["B-Hit", "B-Hit"],
                      ["C-Long-Hit-Committed", "C-Long Hit Committed"],
                      ["C-Split", "C-Split"],
                      ["A-Site-Ult", "A-Site Ult"],
                      ["B-Site-Ult", "B-Site Ult"],
                      ["C-Site-Ult", "C-Site Ult"]
                    ].map(([id, label]) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="SiteHit-sub"
                          id={`Indiv-Corrode-Yoru-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Corrode-Yoru-${id}`}
                            headingContent={label}
                            pageLocation="/Corrode-Yoru"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Indiv-Corrode-Yoru-${id}`}>
                          <div className="image-selector">{renderMediaButtons(id)}</div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect">
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Attack strat for {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* 2. How to Default As Yoru */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Corrode-Yoru-How-to-Default-As-Yoru"
                  checked={!!openAccordions["How-to-Default-As-Yoru"]}
                  onChange={() => handleAccordionToggle("How-to-Default-As-Yoru")}
                />
                <label htmlFor="Indiv-Corrode-Yoru-How-to-Default-As-Yoru">
                  How to Default As Yoru
                  <Favorites
                    headingId="Indiv-Corrode-Yoru-How-to-Default-As-Yoru"
                    headingContent="How to Default As Yoru"
                    pageLocation="/Corrode-Yoru"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content" data-container-id="Indiv-Corrode-Yoru-How-to-Default-As-Yoru">
                  <ul>
                    {[
                      ["A-Hit-with-4-or-A-Heavy-Default", "A-Hit with 4 / A-Heavy Default"],
                      ["Team-Heavy-B-or-Garage-Default", "Team Heavy B / Garage Default"],
                      ["C-or-Garage-Heavy-Default", "C-Site / Garage Heavy Default"]
                    ].map(([id, label]) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="DefaultYoru-sub"
                          id={`Indiv-Corrode-Yoru-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Corrode-Yoru-${id}`}
                            headingContent={label}
                            pageLocation="/Corrode-Yoru"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Indiv-Corrode-Yoru-${id}`}>
                          <div className="image-selector">{renderMediaButtons(id)}</div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect">
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Default setup: {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* 3. Post Plants */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Corrode-Yoru-Post-Plants"
                  checked={!!openAccordions["Post-Plants"]}
                  onChange={() => handleAccordionToggle("Post-Plants")}
                />
                <label htmlFor="Indiv-Corrode-Yoru-Post-Plants">
                  Post-Plants
                  <Favorites
                    headingId="Indiv-Corrode-Yoru-Post-Plants"
                    headingContent="Post-Plants"
                    pageLocation="/Corrode-Yoru"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content" data-container-id="Indiv-Corrode-Yoru-Post-Plants">
                  <ul>
                    {[
                      ["A-PP-Nano", "A-PP Nano"],
                      ["B-PP-Nano", "B-PP Nano"],
                      ["C-PP-Nano", "C-PP Nano"]
                    ].map(([id, label]) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="PostPlant-sub"
                          id={`Indiv-Corrode-Yoru-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Corrode-Yoru-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Corrode-Yoru-${id}`}
                            headingContent={label}
                            pageLocation="/Corrode-Yoru"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Indiv-Corrode-Yoru-${id}`}>
                          <div className="image-selector">{renderMediaButtons(id)}</div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect">
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Post-plant setup: {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </li>





        
        {/* Common Agent Combos Accordion */}
          <li>
            <input
              type="checkbox"
              name="accordion"
              id="Indiv-Corrode-Yoru-Common-Agent-Combos"
              checked={!!openAccordions["Common-Agent-Combos"]}
              onChange={() => handleAccordionToggle("Common-Agent-Combos")}
            />
            <label htmlFor="Indiv-Corrode-Yoru-Common-Agent-Combos">
              Common Agent Combos
            </label>
            <div
              className="accordian__content"
              data-container-id="Indiv-Corrode-Yoru-Common-Agent-Combos"
            >
              <ul>
                <li>
                  <p>Content about common agent combos...</p>
                </li>
              </ul>
            </div>
          </li>



      </ul>
    </main>



      {/* Footer Section */}
      <section className="footer-section">
        <Footer />
      </section>
    </div>
  );
};

export default CorrodeYoru;
